import { AcDomain } from 'api/entities/Domain'
import { apiSlice, defaultTransformFn } from 'api/apiSlice'

const domainsTags = apiSlice.enhanceEndpoints({ addTagTypes: ['Domains'] })

export const domainsApi = domainsTags.injectEndpoints({
  endpoints: build => ({
    getDomains: build.query<AcDomain[], void>({
      query: () => ({
        url: 'domains',
        method: 'GET',
        isContext: true,
        isAgency: false
      }),
      transformResponse: defaultTransformFn,
      providesTags: ['Domains']
    })
  })
})

export const { useGetDomainsQuery, useLazyGetDomainsQuery } = domainsApi
